import React, { Children } from 'react';
import { motion } from 'framer-motion';
const problems = [{
  num: '1',
  title: 'ENERGIA',
  subtitle: 'OBOSEALĂ. CEAȚĂ MENTALĂ. CĂDERI DE CONCENTRARE.',
  text: 'După prânz, parcă cineva îți trage ștecherul. Ai nevoie de cafea ca să funcționezi, de zahăr ca să te ții treaz și tot nu ajunge. Știi că nu e normal, dar nu înțelegi de ce corpul tău nu mai cooperează, deși la birou ești un profesionist de top.'
}, {
  num: '2',
  title: 'GREUTATEA',
  subtitle: 'EFECTUL YO-YO. DIETE EȘUATE. HAINE CARE NU MAI STAU.',
  text: 'Ai încercat keto, post intermitent, aplicații de calorii. Slăbești o lună, recuperezi totul într-un weekend de stres. Te simți ca și cum corpul tău lucrează împotriva ta. Și fiecare eșec îți confirmă teama că poate nu se mai poate face nimic.'
}, {
  num: '3',
  title: 'HAOSUL',
  subtitle: 'PREA MULTĂ INFORMAȚIE. NICIUN PLAN CLAR.',
  text: 'Citești despre nutriție, asculți podcasturi, urmărești experți pe social media. Toți spun altceva. Ești copleșit de sfaturi contradictorii și nu știi de unde să începi. Ești expert în optimizarea proceselor la muncă, dar în farfuria ta e dezordine totală.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Problems() {
  return <section className="bg-navy py-16 lg:py-20" data-id="element-221">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-223">
          <h2 className="text-3xl md:text-4xl font-montserrat font-bold text-pearl" data-id="element-224">
            Te regăsești în cel puțin una din aceste situații?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-225">
          {problems.map((prob, idx) => <motion.div key={idx} variants={itemVariants} className="bg-white rounded-lg p-8 md:p-10 shadow-lg border border-border-subtle relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-226">
              {/* Large Editorial Number */}
              <div className="font-lora text-[100px] leading-none text-gold font-light opacity-30 absolute top-4 left-6 pointer-events-none select-none group-hover:opacity-50 transition-opacity duration-300" data-id="element-227">
                {prob.num}
              </div>

              <div className="relative z-10 mt-16" data-id="element-228">
                <h3 className="font-montserrat font-bold text-navy text-2xl mb-2 text-center md:text-left" data-id="element-229">
                  {prob.title}
                </h3>
                <p className="font-inter text-[17px] font-semibold tracking-wider text-gold uppercase mb-6 text-center md:text-left" data-id="element-230">
                  {prob.subtitle}
                </p>
                <p className="font-inter text-text-medium leading-relaxed" data-id="element-231">
                  {prob.text}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}